import Text from '@components/atoms/Text/Text'
import Translate from '@components/atoms/Translate/Translate'
import { FETCH_STATUS_PENDING, ROUTE_UPLOAD } from '@config/constants'
import {
  actionFetchSujets,
  actionResetCompositeUpload,
  actionSetStep,
  actionSetSujet,
} from '@store/reducers/app'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import c from 'classnames'
import styles from './StepSelect.module.scss'
// import Loader from '@components/atoms/Loader/Loader'
import SujetSelectBox from '@components/molecules/SujetSelectBox/SujetSelectBox'
import { useCallback } from 'react'
import Button from '@components/molecules/Button/Button'

import { sendEvent } from '@utils/tracking'

const StepSelect = () => {
  const gtmEvent = {
    name: 'sujet.step1',
    category: 'sujet testen',
    action: 'sujet.step1',
  }
  const dispatch = useDispatch()

  const { fetchStatus, sujets, selectedSujet } = useSelector(
    (state) => state.app
  )

  const isLoading = fetchStatus === FETCH_STATUS_PENDING

  useEffect(() => {
    dispatch(actionSetStep(0))
  }, [])

  useEffect(() => {
    if (!sujets) {
      dispatch(actionFetchSujets())
    }
  }, [sujets])

  const onSelectSujet = useCallback(
    (id) => {
      const sujet = sujets.find((s) => s.id === id)
      if (!sujet) {
        throw new Error('Could not set selected sujet. Not found')
      }
      dispatch(actionSetSujet(sujet))
      dispatch(actionResetCompositeUpload())
    },
    [sujets]
  )

  const sujetJsx = useMemo(
    () => (
      <>
        {(sujets &&
          sujets.map((s, key) => (
            <div key={key} className="o-grid__col u-mt u-2/10@md">
              <SujetSelectBox
                sujet={s}
                onSelect={onSelectSujet}
                selected={selectedSujet && selectedSujet.id === s.id}
              />
            </div>
          ))) ||
          null}
      </>
    ),
    [sujets, selectedSujet]
  )

  return (
    <div className={styles.base}>
      <div className="o-grid">
        <div className="o-grid__col u-6/14@md u-push-4/14@md">
          <div className={styles.headline}>
            <Text type="h2">
              <Translate str="steps.select.chooseHeadline" />
            </Text>
          </div>
          <div className={styles.description}>
            <Text type="text-m">
              <Translate str="steps.select.chooseDescription" />
            </Text>
          </div>
        </div>
        <div
          className={c([
            styles.sujets,
            'o-grid__col',
            'u-push-2/14@md',
            'u-10/14@md',
          ])}
        >
          {(sujets && (
            <div className={c([styles.sujetsGrid, 'o-grid'])}>{sujetJsx}</div>
          )) ||
            null}
          {(isLoading && (
            <div className={styles.loading}>
              <Text type="h3">Bitte warten...</Text>
              <br />
              <Text type="text-l">Werbeflächen werden geladen</Text>
            </div>
          )) ||
            null}
        </div>
      </div>

      {(selectedSujet && (
        <div className={styles.cta}>
          <Button
            icon="arrow-long-right"
            link={ROUTE_UPLOAD}
            event={gtmEvent}
            onClick={() =>
              sendEvent(gtmEvent.name, gtmEvent.category, gtmEvent.action)
            }
          >
            <Translate str="steps.select.cta" />
          </Button>
        </div>
      )) ||
        null}
    </div>
  )
}

export default StepSelect
